import apiClient from '@/api/client';
import type { FreightRestrictionRecord } from '@/types/freightRestrictions';

export async function fetchFreightRestriction(
  wayId: number,
  signal?: AbortSignal,
): Promise<FreightRestrictionRecord> {
  const response = await apiClient.get<FreightRestrictionRecord>(
    `/api/v1/freight-restrictions/${wayId}`,
    { signal },
  );
  return response.data;
}
